import {
  REQUEST_DELETE_REPORT,
  RESPONSE_DELETE_REPORT,
  REQUEST_DELETE_REPORT_FAILURE
} from './../actions/deleteReportActions'

import { states as queriesStates } from './queriesStates'

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  deleteId: null,
  errors: [],
}

const deleteReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DELETE_REPORT:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.REQUEST,
          deleteId: action.id
        }
      )
    case RESPONSE_DELETE_REPORT:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.READY,
          deleteId: null
        }
      )
    case REQUEST_DELETE_REPORT_FAILURE:
      return Object.assign(
        {},
        state,
        {
          dataState: queriesStates.FAILURE,
          deleteId: null,
          errors: action.errors
        }
      )
    default:
      return state
  }
}

export default deleteReportReducer